// removed by extract-text-webpack-plugin
module.exports = {"root":"Paginator__root___w0DCa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTable/TableControls/Paginator/Paginator.scss
// module id = 1026
// module chunks = 0